import { render, staticRenderFns } from "./ProductCardBadges.vue?vue&type=template&id=0a48cf57&"
import script from "./ProductCardBadges.vue?vue&type=script&lang=js&"
export * from "./ProductCardBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a48cf57')) {
      api.createRecord('0a48cf57', component.options)
    } else {
      api.reload('0a48cf57', component.options)
    }
    module.hot.accept("./ProductCardBadges.vue?vue&type=template&id=0a48cf57&", function () {
      api.rerender('0a48cf57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/product-card/ProductCardBadges.vue"
export default component.exports